import publicApi from "../../publicApi";
import { productsModels } from "../Models/products.models.ts";

export const productsService = {
  getProducts: async () => {
    const response = await publicApi.get("/products");
    return productsModels.transform(response.data);
  },
};
